<script>
import range from 'lodash/range';
import pdfjs from 'pdfjs-dist';

function getDocument(url) {
    return pdfjs.getDocument(url);
}

function getPages(pdf, first, last) {
    const allPages = range(first, last + 1).map(number => pdf.getPage(number));
    return Promise.all(allPages);
}


function getDefaults() {
    return {
        pages: [],
        cursor: 0,
    };
}

export default {
    name: 'PDFDataCustom',

    props: {
        url: '',
    },

    data() {
        return Object.assign(getDefaults(), {
            pdf: undefined,
        });
    },

    watch: {
        url: {
            handler(url) {
                if (url !== null) {
                    getDocument(url)
                        .then(pdf => (this.pdf = pdf))
                        .catch(response => {
                            this.$emit('document-errored', {text: 'Failed to retrieve PDF', response});
                        });
                }
            },
            immediate: true,
        },

        pdf(pdf, oldPdf) {
            if (!pdf) return;
            if (oldPdf) Object.assign(this, getDefaults());

            this.$emit('page-count', this.pageCount);
            this.fetchPages();
        },
    },

    computed: {
        pageCount() {
            return this.pdf ? this.pdf.numPages : 0;
        },
    },

    methods: {
        fetchPages(currentPage = 0) {
            if (!this.pdf) return;
            if (this.pageCount > 0 && this.pages.length === this.pageCount) return;

            const startIndex = this.pages.length;
            if (this.cursor > startIndex) return;

            const startPage = startIndex + 1;
            const endPage = Math.min(Math.max(currentPage, startIndex + this.pageCount), this.pageCount);
            this.cursor = endPage;

            getPages(this.pdf, startPage, endPage)
                .then((pages) => {
                    const deleteCount = 0;
                    this.pages.splice(startIndex, deleteCount, ...pages);
                    return this.pages;
                })
                .catch((response) => {
                    this.$emit('document-errored', {text: 'Failed to retrieve pages', response});
                });
        },

    },

    created() {

    },

    render(h) {
        return h('div', [
            this.$scopedSlots.slides({
                pages: this.pages,
            }),
        ]);
    },
};
</script>
